export default "__VITE_ASSET__c22227aa__"